import * as PROXY from '../../../common/api.js';
import * as PEGASUS from '@smatch/pegasus-api-docs';
import { CONTACT_STORE, CONTACT_HASH } from './store.js';
export * from './types.js';
/* eslint-disable arrow-body-style */
// Filter Contacts
export const filterContacts = async (parameters = {}) => {
    return PROXY.handleFilter(PEGASUS.filterContacts, parameters)
        .then(contacts => PROXY.updateStoreBulk(CONTACT_STORE, contacts));
};
// Fetch Contact
export const fetchContact = async (keys, onError) => {
    return PROXY.handleFetch(PEGASUS.fetchContact, keys)
        .then(({ data, statusCode }) => {
        if (onError?.(statusCode) === true) {
            return {};
        }
        if (statusCode !== 'STATUS_200') {
            PROXY.handleApiError(statusCode);
            return {};
        }
        return PROXY.updateStore(CONTACT_STORE, null, data);
    });
};
// Create Contact
export const createContact = async (body) => {
    return PROXY.handleCreate(PEGASUS.createContact, body)
        .then(response => PROXY.updateStore(CONTACT_STORE, CONTACT_HASH, response));
};
// Update Contact
export const updateContact = async (keys, body) => {
    return PROXY.handleUpdate(PEGASUS.updateContact, keys, body)
        .then(response => PROXY.updateStore(CONTACT_STORE, CONTACT_HASH, response));
};
// Delete Contact
export const deleteContact = async (keys) => {
    return PROXY.handleDelete(PEGASUS.deleteContact, keys)
        .then(response => PROXY.removeFromStore(CONTACT_STORE, CONTACT_HASH, keys.contactKey, response));
};
/* eslint-enable arrow-body-style */ 
